<template>
    <div>
        <div class="dependents-container">
            <div class="icon">
                <i class="fa fa-square-plus fa-2xl fa-regular icon" @click="changeDependentMenuVisibility"></i>
            </div>
            <div class="list-fields">
                <h1>Nome</h1>
                <h1 v-if="showRA">RA</h1>
            </div>
            <div class="list">
                <div class="list-item" v-for="(item, key) in getDependentsData" :key="key" @click="selectDependent(item)">
                    <div class="list-item-field">
                        <h1 v-text="item.nome"></h1>
                    </div>
                    <div class="list-item-field" v-if="showRA">
                        <h1 v-text="item.ra"></h1>
                    </div>
                </div>
            </div>
            <div v-if="getDependentsData.length === 0" class="empty-list">
                <h1>Nenhum dependente cadastrado</h1>
            </div>
        </div>

        <DependentRegisterComponent @addDependent="addDependent"></DependentRegisterComponent>
        <DeleteItemComponent :itemName="'Deletar Dependente'" @deleteEvent="deleteDependent"></DeleteItemComponent>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteItemComponent from '../bottom-popups/DeleteItemComponent.vue'
import DependentRegisterComponent from '../bottom-popups/DependentRegisterComponent.vue'
import { getEnv } from '@/libs/Environment.js'

export default {
    name: 'DependentsComponent',
    components: {
        DependentRegisterComponent,
        DeleteItemComponent
    },
    data () {
        return {
            dependentsList: [],
            selectedDependent: null
        }
    },
    computed: {
        ...mapGetters(['getDependentsData']),
        showRA () {
            return getEnv().usa_registro_academico_automatico !== 'S'
        }
    },
    methods: {
        ...mapActions(['changeDependentMenuVisibility', 'changeDeleteItemVisibility', 'addDependentsData', 'setDependentsData']),
        selectDependent (dependent) {
            this.selectedDependent = dependent
            this.changeDeleteItemVisibility()
        },
        addDependent (dependent) {
            this.addDependentsData(dependent)
        },
        deleteDependent () {
            const dependensList = this.getDependentsData.filter(item => item.ra !== this.selectedDependent.ra)
            this.setDependentsData(dependensList)
            this.changeDeleteItemVisibility()
        }
    }
}
</script>

<style lang="less" scoped>
.dependents-container {
    position: relative;
    display: block;
    height: 100%;
    background-color: #fff;

    .icon {
        margin-top: 20px;
    }

    .list-fields {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
    }

    .list-item {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-bottom: 20px;
        padding: 20px 10px;
        border: 1px solid rgba(0, 0, 0, 0.18);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .empty-list {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        h1 {
            font-weight: 600;
        }
    }
}
</style>
